import { Toast } from '@moia-dev/pace-web'
import type { SnackbarKey } from 'notistack'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

type MoiaErrorNotificationProps = {
  message: string
  notificationKey: SnackbarKey
  title?: string
  ref?: React.Ref<HTMLDivElement>
}

export const MoiaErrorNotification = ({
  notificationKey,
  message,
  title,
  ref,
}: MoiaErrorNotificationProps) => {
  const { closeSnackbar } = useSnackbar()
  const { t } = useTranslation()

  return (
    <div ref={ref} role="alert">
      <Toast
        variant="critical"
        action={() => closeSnackbar(notificationKey)}
        actionLabel={t('common_ok_label')}
        title={title}
      >
        {message}
      </Toast>
    </div>
  )
}
